import classNames from 'classnames';
import React, { memo } from 'react';
import { formatCurrency } from '../../utils/formatters.util';

const BulkPricingTiers = ({ rates, uomData, className = '', showMoreTiersNote }) => {
  return (
    <div className={classNames(className)}>
      <table className='tw:w-full tw:text-body tw:text-xs'>
        <thead>
          <tr className='tw:w-full tw:border-b tw:border-[#d3d3d3] tw:last:border-b-0'>
            <th className='tw:border-b tw:border-[#d3d3d3] tw:py-1 tw:text-left'>Qty.</th>
            <th
              className={classNames('tw:border-b tw:border-[#d3d3d3] tw:py-1', {
                'tw:text-left': !uomData.isCase,
                'tw:text-center': uomData.isCase,
              })}>
              Per Unit
            </th>
            {uomData.isCase && (
              <React.Fragment>
                <th className='tw:border-b tw:border-[#d3d3d3] tw:py-1 tw:text-center'>Case Qty.</th>
                <th className='tw:border-b tw:border-[#d3d3d3] tw:py-1 tw:text-center'>Case Price</th>
              </React.Fragment>
            )}
          </tr>
        </thead>
        <tbody>
          {rates.map((rate) => (
            <tr
              key={`${rate.quantityFormatted}-${rate.rate}`}
              className='tw:w-full tw:border-b tw:border-[#d3d3d3] tw:last:border-b-0'>
              <td className='tw:py-1 tw:text-left'>{rate.quantityFormatted}</td>
              <td
                className={classNames('tw:py-1', {
                  'tw:text-right': !uomData.isCase,
                  'tw:text-center': uomData.isCase,
                })}>
                {formatCurrency(rate.rate / (uomData.isCase ? uomData.conversion : 1))}
              </td>
              {uomData.isCase && (
                <React.Fragment>
                  <td className='tw:py-1 tw:text-center'>{uomData.name}</td>
                  <td className='tw:py-1 tw:text-right'>{formatCurrency(rate.rate)}</td>
                </React.Fragment>
              )}
            </tr>
          ))}
        </tbody>
      </table>
      {showMoreTiersNote && (
        <small className='tw:text-center tw:text-xs tw:leading-normal tw:block tw:mt-2.5'>
          Interested in purchasing more?{' '}
          <span className='tw:ml-1'>Submit your Quote today to learn more.</span>
        </small>
      )}
    </div>
  );
};

export default memo(BulkPricingTiers);
